import { PlaceItemComponent } from './place-item.component';

export default angular
  .module('sfMobile.components.place-item', [
    'sfMobile.services.address-format',
    'pascalprecht.translate',
  ])
  .component('sfPlaceItem', PlaceItemComponent).name;
